import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import HaloRing from "@/components/HaloRing";

export default function ForcePasswordChange({ user, onDone, onSignOut }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("Those two passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password set — welcome aboard");
      await onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not set that password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4"
         data-testid="force-password-screen">
      <Card className="studio-card w-full max-w-md">
        <CardHeader className="space-y-2">
          <HaloRing size={28} />
          <CardTitle className="text-xl">Set your own password</CardTitle>
          <p className="text-sm text-muted-foreground">
            Hi {user?.name?.split(" ")[0] || "there"} — you're signed in with a temporary password.
            Choose your own to carry on.
          </p>
        </CardHeader>
        <CardContent>
          <form className="space-y-4" onSubmit={submit}>
            <div>
              <Label className="text-xs">Temporary password</Label>
              <Input data-testid="force-current-password" type="password" value={current}
                     onChange={(e) => setCurrent(e.target.value)} required />
            </div>
            <div>
              <Label className="text-xs">New password (min 8 characters)</Label>
              <Input data-testid="force-new-password" type="password" value={next} minLength={8}
                     onChange={(e) => setNext(e.target.value)} required />
            </div>
            <div>
              <Label className="text-xs">Confirm new password</Label>
              <Input data-testid="force-confirm-password" type="password" value={confirm} minLength={8}
                     onChange={(e) => setConfirm(e.target.value)} required />
            </div>
            <Button type="submit" className="w-full" data-testid="force-password-submit" disabled={saving}>
              {saving ? "Saving…" : "Save and continue"}
            </Button>
            <Button type="button" variant="ghost" className="w-full" data-testid="force-password-signout"
                    onClick={onSignOut}>
              Sign out instead
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
